import React from 'react'

export const AllChainsLogo = (props: React.HTMLAttributes<SVGElement>) => {
  return (
    <svg
      width="269"
      height="269"
      viewBox="0 0 269 269"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_9457_8334"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="11"
        y="11"
        width="119"
        height="119"
      >
        <path
          d="M111.65 11.1951H28.9226C19.1321 11.1951 11.1953 19.1318 11.1953 28.9224V111.65C11.1953 121.44 19.1321 129.377 28.9226 129.377H111.65C121.441 129.377 129.377 121.44 129.377 111.65V28.9224C129.377 19.1318 121.441 11.1951 111.65 11.1951Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_9457_8334)">
        <path
          d="M111.65 11.1951H28.9226C19.1321 11.1951 11.1953 19.1318 11.1953 28.9224V111.65C11.1953 121.44 19.1321 129.377 28.9226 129.377H111.65C121.441 129.377 129.377 121.44 129.377 111.65V28.9224C129.377 19.1318 121.441 11.1951 111.65 11.1951Z"
          fill="#F7931A"
        />
        <path
          d="M96.3462 61.8671C97.5225 54.0033 91.5349 49.7763 83.3473 46.9564L86.0034 36.3043L79.5184 34.6886L76.9328 45.0602C75.2279 44.6351 73.4771 44.2345 71.737 43.8373L74.3414 33.3972L67.8604 31.7815L65.2028 42.4301C63.792 42.1089 62.4063 41.7915 61.062 41.457L61.0695 41.4235L52.1265 39.1906L50.4014 46.1162C50.4014 46.1162 55.2128 47.2189 55.1114 47.2868C57.7374 47.9422 58.2123 49.6804 58.1335 51.0581L55.1079 63.1934C55.2887 63.2393 55.5233 63.3057 55.7821 63.4097C55.5657 63.356 55.3355 63.2974 55.0966 63.2402L50.8558 80.24C50.5349 81.0377 49.7203 82.2349 47.8843 81.7803C47.9493 81.8745 43.1709 80.6042 43.1709 80.6042L39.9512 88.0266L48.3903 90.1301C49.9603 90.5238 51.4988 90.9357 53.0139 91.323L50.3304 102.097L56.8079 103.713L59.4654 93.0531C61.235 93.5335 62.9523 93.9765 64.6335 94.3942L61.9849 105.004L68.4702 106.62L71.1534 95.8655C82.2118 97.9581 90.5267 97.1144 94.0266 87.1133C96.8468 79.0612 93.8862 74.4168 88.0685 71.3881C92.3058 70.411 95.4975 67.6244 96.3485 61.8679L96.3462 61.8671ZM81.5295 82.6416C79.5253 90.6937 65.9666 86.341 61.5707 85.2495L65.1318 70.9754C69.5274 72.0727 83.6237 74.2441 81.5295 82.6416ZM83.5351 61.7504C81.7068 69.0746 70.4218 65.3536 66.761 64.4411L69.9896 51.4954C73.6504 52.4078 85.439 54.1108 83.5351 61.7504Z"
          fill="white"
        />
      </g>
      <path
        d="M240.078 11.1951H157.35C147.56 11.1951 139.623 19.1318 139.623 28.9224V111.65C139.623 121.44 147.56 129.377 157.35 129.377H240.078C249.868 129.377 257.805 121.44 257.805 111.65V28.9224C257.805 19.1318 249.868 11.1951 240.078 11.1951Z"
        fill="#2151F5"
      />
      <path
        d="M154.396 66.5192H220.321V73.974H154.396C154.407 78.2573 155.803 82.8428 157.382 86.7837C164.783 105.261 183.836 116.345 203.498 114.38C225.114 112.221 242.926 93.0306 243.032 71.2441C243.057 65.9361 242.33 60.621 240.541 55.5994C235.502 41.4618 223.498 30.5974 208.86 27.1329C188.033 22.2037 166.118 33.3099 157.716 52.9745C155.953 57.0991 154.433 61.9936 154.396 66.5192Z"
        fill="white"
      />
      <mask
        id="mask1_9457_8334"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="11"
        y="139"
        width="119"
        height="119"
      >
        <path
          d="M111.65 139.623H28.9226C19.1321 139.623 11.1953 147.56 11.1953 157.35V240.078C11.1953 249.868 19.1321 257.805 28.9226 257.805H111.65C121.441 257.805 129.377 249.868 129.377 240.078V157.35C129.377 147.56 121.441 139.623 111.65 139.623Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_9457_8334)">
        <path
          d="M111.65 139.623H28.9226C19.1321 139.623 11.1953 147.56 11.1953 157.35V240.078C11.1953 249.868 19.1321 257.805 28.9226 257.805H111.65C121.441 257.805 129.377 249.868 129.377 240.078V157.35C129.377 147.56 121.441 139.623 111.65 139.623Z"
          fill="#FF0000"
        />
        <path
          d="M70.2868 240.799C93.5298 240.799 112.372 221.957 112.372 198.714C112.372 175.471 93.5298 156.629 70.2868 156.629C47.0439 156.629 28.2017 175.471 28.2017 198.714C28.2017 221.957 47.0439 240.799 70.2868 240.799Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M70.2864 257.805C102.922 257.805 129.378 231.349 129.378 198.714C129.378 166.079 102.922 139.623 70.2864 139.623C37.6514 139.623 11.1953 166.079 11.1953 198.714C11.1953 231.349 37.6514 257.805 70.2864 257.805ZM48.0469 214.945C49.6636 215.454 51.4151 215.708 53.3013 215.708C57.6426 215.708 61.1006 214.706 63.6753 212.7C66.25 210.664 68.0464 207.595 69.0644 203.493C69.3639 202.206 69.6483 200.918 69.9177 199.631C70.2172 198.343 70.4715 197.041 70.6812 195.724C71.0404 193.688 70.9806 191.907 70.5015 190.38C70.0524 188.853 69.259 187.565 68.1213 186.517C67.0135 185.47 65.6513 184.691 64.0346 184.182C62.4479 183.643 60.7113 183.374 58.8251 183.374C54.454 183.374 50.9809 184.422 48.4062 186.517C45.8315 188.613 44.05 191.682 43.062 195.724C42.7625 197.041 42.4633 198.343 42.1638 199.631C41.8943 200.918 41.6398 202.206 41.4003 203.493C41.0711 205.529 41.1309 207.31 41.58 208.837C42.0591 210.364 42.8523 211.637 43.9602 212.655C45.068 213.673 46.4302 214.436 48.0469 214.945ZM58.1515 207.804C56.924 208.762 55.5018 209.241 53.8851 209.241C52.2384 209.241 51.0558 208.762 50.3373 207.804C49.6187 206.846 49.4391 205.319 49.7984 203.224C50.0378 201.906 50.2775 200.664 50.5169 199.496C50.7864 198.329 51.0858 197.116 51.4151 195.859C51.924 193.763 52.7773 192.236 53.9749 191.278C55.2024 190.32 56.6246 189.841 58.2413 189.841C59.858 189.841 61.0406 190.32 61.7891 191.278C62.5377 192.236 62.7173 193.763 62.3281 195.859C62.1184 197.116 61.879 198.329 61.6095 199.496C61.3701 200.664 61.0855 201.906 60.7562 203.224C60.2473 205.319 59.3789 206.846 58.1515 207.804ZM71.8001 214.945C71.9798 215.155 72.2192 215.259 72.5187 215.259H78.6263C78.9556 215.259 79.2399 215.155 79.4796 214.945C79.7491 214.735 79.9136 214.466 79.9736 214.137L82.0394 204.301H88.1022C91.9644 204.301 95.0331 203.478 97.3086 201.831C99.6138 200.185 101.141 197.64 101.889 194.197C102.249 192.46 102.233 190.949 101.844 189.661C101.455 188.344 100.767 187.251 99.7786 186.383C98.7906 185.515 97.548 184.871 96.0511 184.452C94.584 184.033 92.9373 183.823 91.1111 183.823H79.1652C78.8658 183.823 78.5814 183.928 78.312 184.137C78.0425 184.347 77.8778 184.616 77.818 184.946L71.6205 214.137C71.5604 214.466 71.6205 214.735 71.8001 214.945ZM88.3716 198.104H83.2071L84.9585 190.065H90.3476C91.4255 190.065 92.2187 190.245 92.7278 190.604C93.2668 190.963 93.5811 191.443 93.6709 192.041C93.7607 192.64 93.7307 193.329 93.5811 194.107C93.2816 195.454 92.638 196.457 91.65 197.116C90.6918 197.775 89.5991 198.104 88.3716 198.104Z"
          fill="#FF0000"
        />
      </g>
      <path
        d="M240.078 139.623H157.35C147.56 139.623 139.623 147.56 139.623 157.35V240.078C139.623 249.868 147.56 257.805 157.35 257.805H240.078C249.868 257.805 257.805 249.868 257.805 240.078V157.35C257.805 147.56 249.868 139.623 240.078 139.623Z"
        fill="black"
      />
      <mask
        id="mask2_9457_8334"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="160"
        y="163"
        width="78"
        height="71"
      >
        <path
          d="M237.123 163.998H160.305V233.43H237.123V163.998Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_9457_8334)">
        <mask
          id="mask3_9457_8334"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="160"
          y="163"
          width="78"
          height="71"
        >
          <path
            d="M237.106 163.998H160.305V233.276H237.106V163.998Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_9457_8334)">
          <path
            d="M236.71 218.619L224.032 232.332C223.757 232.63 223.423 232.868 223.053 233.03C222.682 233.192 222.282 233.276 221.878 233.276H161.777C161.49 233.276 161.209 233.191 160.969 233.033C160.73 232.874 160.541 232.648 160.427 232.383C160.312 232.118 160.277 231.825 160.326 231.54C160.375 231.254 160.505 230.99 160.7 230.779L173.388 217.065C173.663 216.768 173.996 216.531 174.365 216.368C174.734 216.206 175.133 216.122 175.536 216.121H235.634C235.921 216.121 236.201 216.206 236.441 216.364C236.681 216.523 236.87 216.749 236.984 217.014C237.098 217.279 237.133 217.573 237.085 217.858C237.036 218.143 236.906 218.407 236.71 218.619ZM224.032 191.003C223.757 190.705 223.423 190.468 223.053 190.305C222.682 190.143 222.282 190.059 221.878 190.06H161.777C161.49 190.06 161.209 190.144 160.969 190.303C160.73 190.461 160.541 190.687 160.427 190.952C160.312 191.218 160.277 191.511 160.326 191.796C160.375 192.081 160.505 192.345 160.7 192.557L173.388 206.271C173.663 206.568 173.996 206.805 174.365 206.967C174.734 207.129 175.133 207.213 175.536 207.214H235.634C235.921 207.214 236.201 207.13 236.441 206.971C236.681 206.812 236.87 206.587 236.984 206.321C237.098 206.056 237.133 205.763 237.085 205.478C237.036 205.193 236.906 204.928 236.71 204.717L224.032 191.003ZM161.777 181.152H221.878C222.282 181.153 222.682 181.069 223.053 180.907C223.423 180.744 223.757 180.507 224.032 180.209L236.71 166.495C236.906 166.284 237.036 166.019 237.085 165.734C237.133 165.449 237.098 165.156 236.984 164.891C236.87 164.625 236.681 164.4 236.441 164.241C236.201 164.082 235.921 163.998 235.634 163.998H175.536C175.133 163.998 174.734 164.083 174.365 164.245C173.996 164.407 173.663 164.644 173.388 164.941L160.704 178.655C160.508 178.866 160.378 179.131 160.329 179.415C160.281 179.7 160.315 179.993 160.429 180.258C160.543 180.523 160.731 180.749 160.971 180.908C161.21 181.067 161.49 181.152 161.777 181.152Z"
            fill="url(#paint0_linear_9457_8334)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_9457_8334"
          x1="166.788"
          y1="234.927"
          x2="230.418"
          y2="163.808"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#9945FF" />
          <stop offset="0.3" stopColor="#8752F3" />
          <stop offset="0.5" stopColor="#5497D5" />
          <stop offset="0.6" stopColor="#43B4CA" />
          <stop offset="0.72" stopColor="#28E0B9" />
          <stop offset="0.97" stopColor="#19FB9B" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default AllChainsLogo
